import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: "dateTime",
})
export class DateTimePipe implements PipeTransform {
  transform(value: Date | string | null): string {
    if (!value) return "";

    const time = new Date(value);
    const hours = time.getHours();
    const minutes = time.getMinutes();
    const amPm = hours >= 12 ? "م" : "ص";

    const formattedTime = `${hours % 12 || 12}:${minutes
      .toString()
      .padStart(2, "0")} ${amPm}`;
    return formattedTime;
  }
}
